import DataFlowAnimation from "@/components/DataFlowAnimation.tsx";

export default function Index() {
  return (
    <div className="relative h-screen w-screen overflow-hidden bg-[#0a0a12]">
      <DataFlowAnimation className="absolute inset-0" />

      <div className="absolute inset-0 grid place-items-center z-10">
        <div
          className="flex flex-col items-center gap-6 p-12 rounded-2xl
                        backdrop-blur-md  border border-white/10
                        shadow-[0_0_10px_rgba(114,111,248,0.15)]"
        >
          <img
            src="/logos/Vitelis_Logomark-Light.svg"
            alt="Vitelis"
            className="h-16 w-auto"
          />
          <h1 className="text-4xl font-semibold text-white tracking-tight">
            Vitelis
          </h1>
        </div>
      </div>
    </div>
  );
}
